import { __awaiter, __generator } from "tslib";
import { compKey } from './key';
export var createSettingsListDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        getEmptyStateContent: function () { return __awaiter(void 0, void 0, void 0, function () {
            var title, description;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$('.empty-state .title').text()];
                    case 1:
                        title = _a.sent();
                        return [4 /*yield*/, base.$('.empty-state .description').text()];
                    case 2:
                        description = _a.sent();
                        return [2 /*return*/, { title: title, description: description }];
                }
            });
        }); },
        getItem: function (idx) { return base.$$('.list-item').get(idx); },
        getItemTitles: function () { return base.$$('.list-item').map(function (i) { return i.$('.profile-title').text(); }); },
        getItemCount: function () { return base.$$('.list-item').count(); },
        addItem: function () { return base.$('.add-account-button').click(); },
        isEmpty: function () { return base.$('.empty-state').exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map